// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inline {
  display: flex;
  align-items: center;
}
.inline label {
  width: 20%;
  margin-bottom: 0;
  font-family: var(--roboto-regular);
}
.inline label.hide {
  color: transparent !important;
}
.inline .input-group {
  width: 80%;
  margin-bottom: 0 !important;
}

.input-group-append {
  position: absolute;
  right: 10px;
  align-items: center;
  display: flex;
  z-index: 20;
  top: 5px;
  height: 35px;
  background: inherit;
  cursor: pointer;
}
.input-group-append ion-icon {
  font-size: 20px;
  color: #262627;
  opacity: 0.5;
}

.form-control-plaintext {
  border-bottom: 1px solid #6c757d;
  border-radius: 0 !important;
}

.verified {
  color: var(--success);
}

.not-verified {
  color: var(--danger);
}

input {
  font-family: var(--roboto-regular);
}
input.no-err-icon {
  background-image: none !important;
  padding-right: 38px;
}

label.hide {
  color: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/elements/input/input.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;AACE;EACE,UAAA;EACA,gBAAA;EACA,kCAAA;AACJ;AACI;EACE,6BAAA;AACN;AAGE;EACE,UAAA;EACA,2BAAA;AADJ;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAFF;AAGE;EACE,eAAA;EACA,cAAA;EACA,YAAA;AADJ;;AAKA;EACE,gCAAA;EACA,2BAAA;AAFF;;AAKA;EACE,qBAAA;AAFF;;AAKA;EACE,oBAAA;AAFF;;AAKA;EACE,kCAAA;AAFF;AAGE;EACE,iCAAA;EACA,mBAAA;AADJ;;AAME;EACE,6BAAA;AAHJ","sourcesContent":[".inline {\n  display: flex;\n  align-items: center;\n\n  label {\n    width: 20%;\n    margin-bottom: 0;\n    font-family: var(--roboto-regular);\n\n    &.hide {\n      color: transparent !important;\n    }\n  } \n\n  .input-group {\n    width: 80%;\n    margin-bottom: 0 !important;\n  }\n}\n\n.input-group-append {\n  position: absolute;\n  right: 10px;\n  align-items: center;\n  display: flex;\n  z-index: 20;\n  top: 5px;\n  height: 35px;\n  background: inherit;\n  cursor: pointer;\n  ion-icon {\n    font-size: 20px;\n    color: #262627;\n    opacity: 0.5;\n  }\n}\n\n.form-control-plaintext {\n  border-bottom: 1px solid #6c757d;\n  border-radius: 0 !important;\n}\n\n.verified {\n  color: var(--success);\n}\n\n.not-verified {\n  color: var(--danger);\n}\n\ninput {\n  font-family: var(--roboto-regular);\n  &.no-err-icon {\n    background-image: none !important;\n    padding-right: 38px;\n  }\n}\n\nlabel {\n  &.hide {\n    color: transparent !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
